/* jshint esnext: true */

const gameTimer = {

	timer: null,

	timerEvent: null,


	/**
	 * Create a timer.
	 */
	create: function( scene ) {

		this.timerEvent = scene.time.addEvent(
			{
				delay: 30000,
				callback: gameplay.end,
				paused: true,
			}
		);

		// Make sure the timer is paused.
		this.pause();

	},


	/**
	 * Start the timer.
	 */
	start: function() {

		this.unpause();

	},


	/**
	 * Add time to the current timer.
	 *
	 * @param {int} duration Number of seconds to add (no milliseconds).
	 * @param {bool} paused Should we pause the game.
	 */
	add: function( duration = 0, paused = false ) {

		const newDelay = ( this.timerEvent.delay - this.timerEvent.elapsed ) + ( duration * 1000 );

		this.timerEvent.reset(
			{
				delay: newDelay,
				callback: gameplay.end,
				paused
			}
		);

		// console.log( 'timer add', newDelay );

	},


	/**
	 * Update the timer gui element.
	 */
	update: function() {

		let currentTime = Math.round( ( this.timerEvent.delay - this.timerEvent.getElapsed() ) / 1000 );

		$( '.time' ).html( currentTime );

	},


	/**
	 * Pause the game timer.
	 */
	pause: function() {

		// console.log( 'game timer pause' );

		gameTimer.timerEvent.paused = true;

	},


	/**
	 * Unpause the timer.
	 */
	unpause: function() {

		// console.log( 'game timer unpause' );

		gameTimer.timerEvent.paused = false;

	},

};
